import { Module } from 'owa-workloads-module';
import { isRunningInMetaOSHub } from 'owa-config';
import getSessionData from 'owa-shared-start/lib/getSessionData';
import type { SessionData } from 'owa-service/lib/types/SessionData';

export const overrideStartConfig = (
    mod: string
): {
    overrideBootPromises?: () => Promise<SessionData>;
    loadBpos?: boolean;
    disableFeature?: {
        offlineSessionData: boolean;
    };
} => {
    return mod == Module.People && isRunningInMetaOSHub()
        ? {
              overrideBootPromises: () => getSessionData(),
              loadBpos: false,
              disableFeature: {
                  offlineSessionData: true,
              },
          }
        : {};
};
